"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelRange = void 0;
/**
 * Pixel Range
 */
class PixelRange {
    /**
     * Constructor
     *
     * @param topLeft
     *            top left pixel
     * @param bottomRight
     *            bottom right pixel
     */
    constructor(topLeft, bottomRight) {
        this.topLeft = topLeft;
        this.bottomRight = bottomRight;
    }
    /**
     * Get the top left pixel
     *
     * @return top left pixel
     */
    getTopLeft() {
        return this.topLeft;
    }
    /**
     * Set the top left pixel
     *
     * @param topLeft
     *            top left pixel
     */
    setTopLeft(topLeft) {
        this.topLeft = topLeft;
    }
    /**
     * Get the bottom right pixel
     *
     * @return bottom right pixel
     */
    getBottomRight() {
        return this.bottomRight;
    }
    /**
     * Set the bottom right pixel
     *
     * @param bottomRight
     *            bottom right pixel
     */
    setBottomRight(bottomRight) {
        this.bottomRight = bottomRight;
    }
    /**
     * Get the minimum x pixel
     *
     * @return minimum x pixel
     */
    getMinX() {
        return this.topLeft.getX();
    }
    /**
     * Get the minimum y pixel
     *
     * @return minimum y pixel
     */
    getMinY() {
        return this.topLeft.getY();
    }
    /**
     * Get the maximum x pixel
     *
     * @return maximum x pixel
     */
    getMaxX() {
        return this.bottomRight.getX();
    }
    /**
     * Get the maximum y pixel
     *
     * @return maximum y pixel
     */
    getMaxY() {
        return this.bottomRight.getY();
    }
    /**
     * Get the left pixel
     *
     * @return left pixel
     */
    getLeft() {
        return this.getMinX();
    }
    /**
     * Get the top pixel
     *
     * @return top pixel
     */
    getTop() {
        return this.getMinY();
    }
    /**
     * Get the right pixel
     *
     * @return right pixel
     */
    getRight() {
        return this.getMaxX();
    }
    /**
     * Get the bottom pixel
     *
     * @return bottom pixel
     */
    getBottom() {
        return this.getMaxY();
    }
    /**
     * Get the pixel width
     *
     * @return pixel width
     */
    getWidth() {
        return this.getMaxX() - this.getMinX();
    }
    /**
     * Get the pixel height
     *
     * @return pixel height
     */
    getHeight() {
        return this.getMaxY() - this.getMinY();
    }
}
exports.PixelRange = PixelRange;
//# sourceMappingURL=PixelRange.js.map